











































































































metaMixin = require '@/mixins/meta'

import GeotapLogo from '@/components/GeotapLogo'
import Footer from '@/components/Footer'

export default {
  name: 'presskit-page',

  mixins: [metaMixin]

  components: 
    'geotap-logo': GeotapLogo
    'lucre-footer': Footer

  data: -> 
    meta: 
      title: 'Presskit for GeoTap by Lucre Games'
      description: 'Geotap is Lucre Games’ first mobile launch and was thought to be simple a exercise in shipping a title with the goal creating a platform to launch games with emotionally rich experiences that ride a fine line between pure art experiences and traditional game play.'
      image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game-press-kit.png'
      route: '/presskit'

    promo: [
      require '@/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-1.png'
      require '@/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-2.png'
      require '@/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-3.png'
      require '@/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-4.png'
      require '@/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-5.png'
    ]

    logos: [
      require '@/assets/images/geotap-game-logo-lucre-games-white.png'
      require '@/assets/images/geotap-game-logo-lucre-games-black.png'
    ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PressKit.vue